module.exports = __webpack_public_path__ + "static/media/how-it-works-1.988f1b3d.png";